// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"63123046","238":"f4d16693","332":"48a79832","453":"67926b31","633":"7e374bb8"}[chunkId] + ".chunk.js";
};